<div class="product-top-filter">
    <div class="row">
        <div class="col-12">
            <div class="product-filter-content">
                <!-- <div class="search-count">
                    <h5>Showing Products 1-{{ products.length }} of {{ paginate.totalItems }} Result</h5>
                </div> -->

                <!-- totalCount: {{pagination.totalCount}}
                <pre>
                    {{pagination|json}}
                </pre> -->
                <ng-container *ngIf="paginationHidden">
                    <mat-paginator #paginator [length]="pagination.totalCount" [pageSize]="pagination.pageSize"
                        [pageSizeOptions]="[48, 96]" [showFirstLastButtons]="true" (page)="switchPage($event)">
                    </mat-paginator>
                </ng-container>


                <div class="product-page-filter " style="background: #1b185d; " *ngIf="filterHidden">
                    <select (change)="onFilterBy($event)"
                        style="color:rgb(237, 230, 230); margin-left: 4px; font-weight: bold; background: #1b185d;">
                        <option value="">{{'Filters'|translate}}</option>
                        <option value="TravelSize" [selected]="filterBy == 'TravelSize'"> {{'Travel Size'|translate}}
                        </option>
                        <option value="BestSeller" [selected]="filterBy == 'BestSeller'">{{'best sellers'|translate}}
                        </option>
                        <option value="Clearance" [selected]="filterBy == 'Clearance'">{{'Clearance'|translate}}
                        </option>
                        <option value="Gifts" [selected]="filterBy == 'Gifts'">{{'Gifts'|translate}}</option>
                        <!-- <option value="LimitedTime" [selected]="filterBy == 'LimitedTime'">{{'Limited Time'|translate}}
                        </option> -->
                        <option value="NewProduct" [selected]="filterBy == 'NewProduct'">{{'New Products'|translate}}
                        </option>
                        <option value="SpecialOffer" [selected]="filterBy == 'SpecialOffer'">{{'Special
                            Offer'|translate}}</option>
                        <option value="OnSale" [selected]="filterBy == 'OnSale'">{{'Sale'|translate}}</option>
                    </select>
                </div>

                <div class="product-page-filter" style="background: #1b185d;" *ngIf="filterHidden">
                    <select (change)="sorting($event)"
                        style="color:rgb(237, 230, 230); margin-left: 4px; font-weight: bold; background: #1b185d;">
                        <option value="">{{'Sort By'|translate}}</option>
                        <option value="brandName asc" [selected]="sortBy == 'brandName asc'">{{'Alphabetically
                            A-Z'|translate}} </option>
                        <option value="brandName desc" [selected]="sortBy == 'brandName desc'">{{'Alphabetically
                            Z-A'|translate}}</option>
                        <option value="unitPrice asc" [selected]="sortBy == 'unitPrice asc'">{{'Price Low to
                            High'|translate}}</option>
                        <option value="unitPrice desc" [selected]="sortBy == 'unitPrice desc'">{{'Price High to
                            Low'|translate}}</option>
                    </select>
                </div>


            </div>
        </div>
    </div>
</div>